import { omit } from 'es-toolkit';
import React, { ReactElement } from 'react';
import { Box, Typography, TypographyProps } from '@mui/material';

interface Props extends TypographyProps {
  text: string | ReactElement;
  pushButtonsRight?: boolean;
}

export function TypographyWithActionButtons(props: Props) {
  return (
    <Typography
      {...omit(props, ['text', 'children', 'className', 'pushButtonsRight'])}
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        { display: 'flex', flexWrap: 'wrap', alignItems: 'center' },
      ]}
    >
      {props.text}
      <Box sx={props.pushButtonsRight ? { flexGrow: 1 } : { width: 16 }} />
      {props.children}
    </Typography>
  );
}
